/** @type {{ [key: string]: { unit: '円' | '万円'; path: string[] }}} */
export const incomeDisplayConfig = {
    時給: {
        unit: '円',
        path: ['hourlyIncomeMin', 'hourlyIncomeMax'],
    },
    日給: {
        unit: '円',
        path: ['daylyIncomeMin', 'daylyIncomeMax'],
    },
    月給: {
        unit: '万円',
        path: ['monthlyIncomeMin', 'monthlyIncomeMax'],
    },
    年収: {
        unit: '万円',
        path: ['annualIncomeMin', 'annualIncomeMax'],
    },
    固定給: {
        unit: '万円',
        path: ['incomeDisplayMin', 'incomeDisplayMax'],
    },
}

const round = (n) => Math.floor(n * 10) / 10

// class 固有 path 欠落 (例: daylyIncome typo) を吸収する fallback
const pickFiniteNumber = (...candidates) => {
    for (const v of candidates) {
        if (typeof v === 'number' && Number.isFinite(v)) return v
    }
    return undefined
}

export const getIncomeDisplay = (offer) => {
    const c = incomeDisplayConfig[offer.incomeDisplayClass]
    if (!c) {
        return ''
    }
    const [fromPath, toPath] = c.path
    const fromValue = pickFiniteNumber(offer[fromPath], offer.incomeDisplayMin)
    const toValue = pickFiniteNumber(offer[toPath], offer.incomeDisplayMax)
    if (fromValue === undefined && toValue === undefined) {
        return ''
    }
    if (fromValue === undefined) {
        const to = round(toValue)
        if (to === 0) {
            return ''
        }
        return `〜${to.toLocaleString()}${c.unit}`
    }
    const from = round(fromValue)
    const to = toValue !== undefined ? round(toValue) : 0
    if (to === 0) {
        return `${from.toLocaleString()}〜${c.unit}`
    }
    if (from > to) {
        return `${to.toLocaleString()}〜${from.toLocaleString()}${c.unit}`
    }
    return `${from.toLocaleString()}〜${to.toLocaleString()}${c.unit}`
}
